{
  "language": {
    "label": "Idioma"
  },
  "common": {
    "next": "Próximo",
    "previous": "Anterior",
    "cancel": "Cancelar",
    "save": "Salvar",
    "finish": "Finalizar",
    "loading": "Carregando...",
    "home": "Início",
    "numbersOnly": "Insira apenas os números",
    "cancelRegistration": "Cancelar cadastro",
    "smartdocsPortal": "@ Smartdocs Portal",
    "noVersionInfo": "Não existem informações de versão do sistema.",
    "portalDeServicos": "Portal de Serviços",
    "catalog": "Catálogo",
    "requests": "Solicitações"
  },
  "login": {
    "title": "Entrar no Portal de Serviços",
    "passwordLabel": "Senha *",
    "saveCredentials": "Salvar dados para acessos futuros",
    "recaptchaError": "Não foi possível validar sua submissão. Por favor, atualize a página e tente novamente.",
    "submitting": "Entrando...",
    "submit": "Entrar com CPF",
    "forgotPassword": "Esqueci a senha",
    "noAccount": "Ainda não tenho conta",
    "loginError": "Erro ao efetuar Login.",
    "loginErrorTitle": "Erro ao efetuar Login:",
    "tooManyAttempts": "Múltiplas tentativas incorretas. Seu acesso foi bloqueado temporariamente por 15 minutos."
  },
  "forgotPassword": {
    "title": "Esqueci a senha",
    "submitButton": "ENVIAR LINK DE REDEFINIÇÃO",
    "successTitle": "Link para nova senha enviado com sucesso!",
    "successMessage": "Um link para a criação de uma nova senha foi enviado para o e-mail cadastrado.",
    "registeredEmailLabel": "E-mail cadastrado *",
    "accessEmail": "Acesse este e-mail para realizar a alteração."
  },
  "resetPassword": {
    "title": "Criar nova senha",
    "subtitle": "Qual senha deseja utilizar para entrar no portal?",
    "keepPassword": "Guarde a sua senha em um lugar seguro e acessível.",
    "keepPasswordTypo": "Quarde a sua senha em um lugar seguro e acessível.",
    "passwordLabel": "Senha *",
    "confirmPasswordLabel": "Repitar Senha *",
    "saveButton": "Salvar nova senha",
    "successTitle": "Senha alterada com sucesso!",
    "expiredTitle": "O link expirou!",
    "expiredMessage": "O link para redefinição de senha expirou.",
    "requestNewLink": "Solicite novo link de redefinição.",
    "enterPortal": "Entrar no portal"
  },
  "emailValidation": {
    "accountReady": "Sua conta está pronta para uso!",
    "emailMainChannel": "O e-mail é o principal canal de comunicação entre o Portal e você.",
    "checkInbox": "Confira sua caixa de entrada regularmente.",
    "enterPortal": "ENTRAR NO PORTAL",
    "validateEmail": "Valide seu e-mail para liberar o acesso.",
    "requestNewLink": "Solicite novo link de validação.",
    "emailNotValidated": "Seu e-mail ainda não foi validado.",
    "indispensableStep": "Esta etapa é indispensável para liberar seu acesso ao portal.",
    "resendButton": "REENVIAR EMAIL DE VALIDAÇÃO",
    "linkExpires": "O link do e-mail expira em 1 hora.",
    "linkSentSuccess": "Link enviado com sucesso!",
    "almostThere": "Estamos quase lá!",
    "accessEmailToValidate": "Acesse o e-mail enviado pelo Portal e abra o link de validação para ativar a sua conta.",
    "indispensableStepPortal": "Esta etapa é indispensável para liberar seu acesso no portal.",
    "accessRegistrationEmail": "Acesse o e-mail utilizado no cadastro e faça a validação."
  },
  "register": {
    "createAccount": "Criar conta",
    "abandonTitle": "Deseja abandonar o cadastro?",
    "abandonMessage": "Ao sair, você perderá todos os dados inseridos até aqui.",
    "continueRegistering": "Continuar cadastrando",
    "exitRegistration": "Sair do cadastro",
    "steps": {
      "cpf": "Qual é o seu CPF?",
      "fullName": "Qual é o seu nome completo?",
      "contacts": "Quais são os seu contatos?",
      "address": "Qual é o seu endereço?",
      "password": "Qual senha deseja utilizar para entrar no portal?"
    },
    "cpfAlreadyRegistered": "O CPF informado já está registrado. Por favor, insira um CPF diferente.",
    "serviceUnavailable": "Serviço indisponível, tente novamente mais tarde.",
    "fullNameLabel": "Nome completo *",
    "fullNamePlaceholder": "Nome Sobrenome",
    "emailLabel": "E-mail *",
    "emailHelperText": "Escolha um endereço de e-mail de fácil acesso por você.",
    "confirmEmailLabel": "Repetir e-mail *",
    "confirmEmailHelperText": "O e-mail deve ser idêntico ao informado acima.",
    "confirmPasswordLabel": "Repita a senha *",
    "confirmPasswordHelperText": "A senha deve ser idêntica à informada acima.",
    "acceptTerms": "Aceito os",
    "consentTerms": "Termos de Consentimento",
    "cepRequired": "CEP é obrigatório para avançar.",
    "cepDigits": "CEP deve ter 8 dígitos para avançar.",
    "cepInvalid": "CEP inválido. Você pode preencher o endereço manualmente.",
    "ufLabel": "UF",
    "cityLabel": "Cidade *",
    "neighborhoodLabel": "Bairro *",
    "streetLabel": "Logradouro *",
    "streetNumberLabel": "Número *",
    "complementLabel": "Complemento",
    "cellphoneLabel": "Telefone celular *",
    "phoneLabel": "Telefone fixo",
    "returnSuccess": {
      "title": "Conta criada com sucesso!",
      "almostThere": "Estamos quase lá!",
      "emailSent": "Foi enviado um e-mail para o endereço de e-mail informado na criação da conta.",
      "emailLabel": "E-mail informado *",
      "validateAccess": "Acesse este e-mail para validar seu cadastro e acessar o portal.",
      "redirecting": "Redirecionando em {{countdown}} sec ou",
      "clickHere": "clique aqui."
    },
    "returnError": {
      "title": "Escolha outro e-mail para o cadastro",
      "message": "Não conseguimos enviar o link de validação para o e-mail informado",
      "emailLabel": "E-mail informado *",
      "chooseAnother": "Escolha <b>outro</b> endereço de <b>e-mail</b> ao qual você tenha <b>acesso fácil</b>.",
      "emailFieldLabel": "E-mail *",
      "confirmEmailLabel": "Repetir e-mail *"
    }
  },
  "home": {
    "catalog": "Catálogo",
    "requests": "Solicitações",
    "noRequests": "Você ainda não abriu solicitações.",
    "noCategory": "Nenhuma categoria encontrada.",
    "noOrganization": "Nenhuma unidade encontrada.",
    "noService": "Nenhum serviço encontrado.",
    "others": "Outros",
    "startRequest": "Iniciar solicitação",
    "searchPlaceholder": "Localizar uma solicitação",
    "searchTitle": "Acompanhe suas solicitações",
    "searchOrganizationPlaceholder": "Localizar uma unidade",
    "searchOrganizationTitle": "Escolha uma unidade",
    "searchCategoryPlaceholder": "Localizar uma categoria",
    "searchCategoryTitle": "Escolha uma categoria",
    "searchServicePlaceholder": "Localizar um serviço",
    "searchServiceTitle": "Escolha um serviço",
    "noTaskFound": "Nenhuma tarefa encontrada"
  },
  "myAccount": {
    "title": "Minha conta",
    "fullNameLabel": "Nome completo",
    "cpfLabel": "CPF",
    "editPassword": "Editar senha",
    "logout": "Encerrar sessão e sair",
    "logoutDialogTitle": "Desconectar do portal?",
    "logoutDialogMessage": "Encerrar sessão e sair com segurança.",
    "logoutButton": "Desconectar",
    "stayButton": "Permanecer no Portal",
    "deactivateAccount": "Desativar conta",
    "deactivateModalTitle": "Desativar conta permanentemente",
    "deactivateModalWarning": "Atenção: esta ação é irreversível. Ao desativar sua conta, seus dados pessoais serão excluídos e você não poderá mais acessar o portal com este cadastro.",
    "deactivateModalSubtitle": "Informe o motivo e a sua senha para confirmar a desativação permanente da conta.",
    "deactivationReasonLabel": "Motivo da desativação *",
    "deactivationReasonPlaceholder": "Descreva o motivo da desativação...",
    "deactivationPasswordLabel": "Sua senha atual *",
    "proceedButton": "Prosseguir",
    "confirmDeactivationButton": "Confirmar desativação",
    "deactivatingButton": "Desativando...",
    "deactivateSuccess": "Conta desativada com sucesso.",
    "deactivateErrorTitle": "Falha ao desativar conta",
    "deactivateError": "Erro ao desativar conta. Verifique sua senha e tente novamente."
  },
  "editPassword": {
    "breadcrumb": "Minha conta",
    "title": "Editar senha",
    "currentPasswordLabel": "Senha atual *",
    "passwordLabel": "Senha *",
    "confirmPasswordLabel": "Repetir nova senha *",
    "cancelButton": "Cancelar",
    "saving": "Salvando...",
    "saveButton": "Salvar edição",
    "successMessage": "Senha atualizada com sucesso!",
    "errorMessage": "Erro ao atualizar senha. Tente novamente.",
    "incorrectPassword": "A senha está incorreta."
  },
  "requestHistory": {
    "breadcrumbRequests": "Solicitações",
    "historyTitle": "Histórico da solicitação",
    "stepsTab": "Etapas",
    "documentsTab": "Documentos",
    "orderByLabel": "Ordernar por",
    "mostRecent": "Mais recentes",
    "oldest": "Mais antigos",
    "documentsLoadError": "Erro ao carregar os documentos.",
    "noDocuments": "O processo ainda não possui documentos.",
    "processStarted": "Processo iniciado",
    "inProgress": "Em andamento",
    "completed": "Concluída"
  },
  "signature": {
    "signSuccess": "Documento(s) assinado(s) com sucesso!",
    "signError": "Erro ao assinar Documento(s): ",
    "otpResent": "OTP reenviado.",
    "otpResendError": "Erro ao reenviar OTP:",
    "modalTitle": "Assinar documento(s) selecionado(s)",
    "modalDescription": "Use o código recebido pelo seu email para assinar o(s) documento(s).",
    "emailLabel": "E-mail *",
    "codeLabel": "Código *",
    "codePlaceholder": "Código",
    "signAndSend": "Assinar e enviar",
    "returnToDocuments": "Retornar aos documentos",
    "resendOtpTitle": "Reenviar código de assinatura (OTP)",
    "resendOtpDescription": "O código será enviado ao assinante cadastrado e, se adicionado, também ao e-mail informado abaixo",
    "additionalEmailLabel": "E-mail adicional (opcional)",
    "emailPlaceholder": "E-mail",
    "resendOtpButton": "Reenviar OTP"
  },
  "errors": {
    "pageNotFound": "NÃO ENCONTRAMOS ESTA PÁGINA",
    "backToHome": "Voltar para o início",
    "weApologize": "PEDIMOS DESCULPAS!",
    "underMaintenance": "ESTAMOS TEMPORARIAMENTE EM MANUTENÇÃO",
    "somethingWentWrong": "ALGO DEU ERRADO"
  },
  "toast": {
    "userNotFound": "Usuário não encontrado!",
    "accessDenied": "Acesso negado!",
    "emailInUse": "O e-mail já está em uso",
    "emailNeedsVerification": "O e-mail precisa ser verificado!",
    "userDisabled": "Usuário desabilitado.",
    "tokenNotFound": "Confirmação do token não encontrada.",
    "tokenExpired": "Confirmação do token expirada.",
    "incorrectCurrentPassword": "Senha atual incorreta.",
    "incorrectCredentials": "Credenciais incorretas.",
    "unexpectedError": "Ocorreu um erro inesperado. Tente novamente mais tarde."
  },
  "validation": {
    "cpfRequired": "CPF é obrigatório para avançar.",
    "cpfLength": "CPF deve conter 11 números.",
    "cpfInvalid": "CPF inválido. Revise os dados.",
    "cnpjInvalid": "CNPJ inválido",
    "passwordRequired": "Senha é obrigatória para avançar.",
    "passwordRequiredMasc": "Senha é obrigatório para avançar.",
    "requiredField": "Preenchimento obrigatório",
    "invalidBirthDate": "Data de nascimento inválida",
    "cpfRequiredShort": "CPF é obrigatório.",
    "fullNameRequired": "Nome completo é obrigatório para avançar.",
    "emailInvalid": "E-mail inválido",
    "emailRequired": "Email é obrigatório para avançar",
    "emailsMustMatch": "Os e-mails não são idênticos.",
    "confirmEmailRequired": "Repetir e-mail é obrigatório para avançar.",
    "confirmPasswordRequired": "Repetir senha é obrigatório para avançar.",
    "cellphoneRequired": "Telefone celular é obrigatório para avançar",
    "cellphoneInvalid": "Este não é um telefone celular válido",
    "termsRequired": "Para prosseguir, é necessário aceitar os Termos de Consentimento",
    "passwordsMustMatch": "As senhas não são idênticas."
  },
  "password": {
    "requirements": "A senha deve conter:",
    "minMax": "De 8 a 16 dígitos",
    "uppercase": "Letras MAIÚSCULAS",
    "lowercase": "Letras minúsculas",
    "digits": "Números",
    "special": "Caracteres especiais (@ ; # $ , . etc)",
    "required": "Senha é obrigatório para avançar."
  },
  "fullName": {
    "invalidName": "Este não é um nome válido.",
    "requirements": "O nome completo deve conter, pelo menos:",
    "firstName": "01 Nome próprio de 02 letras",
    "lastName": "01 Sobrenome de 02 letras",
    "otherNames": "Outros(s) nome(s) com 02 letras ou mais",
    "noAbbreviation": "Não abrevie o seu nome."
  },
  "document": {
    "cpfLabel": "CPF *"
  }
}
